/* 标签管理-API */

import {post,get} from '../../libs/ajax.js'

export default {
    // 标签维护-一级标签列表
    getLevel1List:(data,options) => {
        return get('/tag_manage/tag/get_level1_list', data, options);
    },
    // 标签维护-获取子标签列表
    getLevel2List:(data,options) => {
        return get('/tag_manage/tag/get_level2_list', data, options);
    },
    // 标签维护-筛选框获取创建者下拉选项
    getCreatorList:(data,options) => {
        return get('/tag_manage/tag/get_creator_list', data, options);
    },
    // 标签维护-修改一级标签
    editLevel1Tag:(data,options) => {
        return post('/tag_manage/tag/edit_level1_tag', data, options);
    },
    // 标签维护-添加子标签
    addLevel2Tag:(data,options) => {
        return post('/tag_manage/tag/add_level2_tag', data, options);
    },
    // 标签维护-删除子标签
    deleteLevel2Tag:(data,options) => {
        return post('/tag_manage/tag/del_level2_tag', data, options);
    },
    //标签维护-编辑子标签
    editLevel2Tag:(data,options) => {
        return post('/tag_manage/tag/edit_level2_tag', data, options);
    },

    // 各标签页列表 - bloc|company|account|plan|subproject
    getDataList(data,options){
        let type = data.apiType||'bloc';
        delete data.apiType;
        return post('/tag_manage/'+type+'/get_list', data, options);
    },
    // 各标签页列表 - 获取搜索下拉框接口
    getSearchList(data,options){
        let type = data.apiType||'bloc';
        delete data.apiType;
        return get('/tag_manage/'+type+'/get_search_list', data, options);
    },
    // 各标签页列表 - 获取自定义字段
    getCustomField(data,options){
        return get('/tag_manage/tag/get_custom_field', data, options);
    },
    // 各标签页列表 - 获取自定义筛选条件
    getCustomFilter(data,options){
        return get('/tag_manage/tag/get_custom_filter', data, options);
    },

    // 各标签页列表 - 保存及批量保存接口
    saveTag(data,options){
        let type = data.apiType||'bloc';
        delete data.apiType;
        return post('/tag_manage/'+type+'/save_tag', data, options);
    },
    // 各标签页列表 - 导出
    exportList(data,options){
        let type = data.apiType||'bloc';
        delete data.apiType;
        return post('/tag_manage/'+type+'/export', data, options);
    },

    // 各标签页列表 - 编辑自定义字段
    setCustomField:(data,options) => {
        return post('/tag_manage/tag/edit_custom_field', data, options);
    },
    // 各标签页列表 - 编辑自定义筛选条件
    setCustomFilter:(data,options) => {
        return post('/tag_manage/tag/edit_custom_filter', data, options);
    },

    // 各标签页列表【媒体】 - 批量搜索下拉选项
    remotePlatOptionsList:(data,options) => {
        return post('/tag_manage/plat/get_plat_search_list', data, options);
    },
    // 各标签页列表【计划】 - 批量搜索下拉选项
    remotePlanOptionsList:(data,options) => {
        return post('/tag_manage/plan/get_plan_search_list', data, options);
    },
    // 各标签页列表【产品】 - 批量搜索下拉选项
    remoteSubProjectOptionsList:(data,options) => {
        return post('/tag_manage/subproject/get_subproject_search_list', data, options);
    },
    // 各标签页列表【项目】 - 批量搜索下拉选项
    remoteProjectOptionsList:(data,options) => {
        return post('/tag_manage/project/get_project_search_list', data, options);
    },

    // 获取计划列表-投放产品搜索下拉框数据
    postAppPackageSearchList:(data,options) => {
        return post('/tag_manage/plan/get_app_package_search_list', data, options);
    },

    // 获取项目列表-产品搜索下拉框数据
    postSubprojectSearchList:(data,options) => {
        return post('/tag_manage/project/get_subproject_search_list', data, options);
    },

    // 媒体-添加媒体
    addPlat:(data,options) => {
        return post('/tag_manage/plat/add', data, options);
    },
    editPlat:(data,options) => {
        return post('/tag_manage/plat/save_tag', data, options);
    },

}
